import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import AuthHeader from '../../components/AuthHeader'
import toast from 'react-hot-toast'

const LoginPage = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  })
  const [loading, setLoading] = useState(false)
  const { login } = useAuth()
  const navigate = useNavigate()

  // Check if all required fields are filled
  const isFormValid = formData.username.trim() !== '' && formData.password.trim() !== ''

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      const result = await login(formData.username, formData.password)
      
      if (result.success) {
        toast.success('Welcome back!')
        navigate('/')
      } else {
        toast.error(result.error)
      }
    } catch (error) {
      toast.error('An unexpected error occurred')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-black">
    <div className='p-4'>
    <div className="border-2 border-white">
      <AuthHeader />
        <div className=' bg-[#141414] p-4 w-full min-h-screen flex items-center justify-center'>
          <div className="w-full max-w-sm relative">

        {/* Form Card */}
        <div className="bg-card border border-gray-700  p-6 relative">
          {/* Tab Navigation */}
          <div className="flex border-b border-gray-700 mb-6 pb-2">
            <Link 
              to="/signup" 
              className="flex-1 py-2 px-4 text-center text-xs font-medium text-gray-400 hover:text-white transition-colors"
            >
              SIGN UP
            </Link>
            <div className="flex-1 py-2 px-4 text-center text-xs font-semibold text-white border-b-2 border-red-600">
              LOG IN
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5 flex flex-col gap-2">
            <div className='flex justify-center items-center !mb-4'>
              <h4>
                Welcome Back to TLP!
              </h4>
            </div>
            <div className="space-y-1">
             
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                className="w-full h-10 px-3 py-2 bg-white border-0 placeholder:text-center text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all font-avenir"
                placeholder="User Name"
                required
                disabled={loading}
              />
            </div>

            <div className="space-y-1">
           
              <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="w-full h-10 px-3 py-2 bg-white border-0 placeholder:text-center text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all font-avenir"
                placeholder="Password"
                required
                disabled={loading}
              />
            </div>

            <div className="flex justify-end mb-5">
              <Link 
                to="/forgot-password" 
                className="text-xs text-white hover:text-red-300 transition-colors"
              >
                Forgot Password?
              </Link>
            </div>
            <div className='!mx-6'>

            <button
              type="submit"
              disabled={loading || !isFormValid}
              className="w-full h-10  bg-red-600 hover:bg-red-700 disabled:bg-red-700 disabled:cursor-not-allowed text-white font-bold text-sm rounded-lg transition-colors flex items-center justify-center uppercase tracking-wide"
            >
              {loading ? (
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  <span>Logging in...</span>
                </div>
              ) : (
                'LOGIN'
              )}
            </button>
            </div>

          </form>

          <div className="mt-6 text-center space-y-2">
         
            <p className="text-xs text-gray-400">
              Not Registered?{' '}
              <Link 
                to="/signup" 
                className="text-red-400 hover:text-red-300 transition-colors font-medium"
              >
                Create An Account
              </Link>
            </p>
          </div>

          {/* Footer Links */}
          <div className="mt-6 pt-4 border-t border-gray-700 flex flex-wrap justify-center gap-3 text-xs">
            <Link
              to="/privacy-policy"
              className="text-gray-400 hover:text-red-300 transition-colors font-avenir"
            >
              Privacy Policy
            </Link>
            <span className="text-gray-600">|</span>
            <Link
              to="/terms-of-use"
              className="text-gray-400 hover:text-red-300 transition-colors font-avenir"
            >
              Terms of Use
            </Link>
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
    </div>
   
  )
}

export default LoginPage